module.exports = __webpack_public_path__ + "02cbcf3316073ee3b6f28255a8c9afa0.svg";